import { VYLABS_USER_DASHBOARD_URL } from "../../../helper/url_helper";

export const fetchWithAuth = async (endpoint, options = {}) => {
  const token = localStorage.getItem("token");
  const method = options.method || "GET";

  const fetchOptions = {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  };
  if (["POST", "PUT", "PATCH"].includes(method.toUpperCase()) && options.body) {
    fetchOptions.body = JSON.stringify(options.body);
  }

  try {
    const response = await fetch(
      `${VYLABS_USER_DASHBOARD_URL}${endpoint}`,
      fetchOptions,
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "API request failed");
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error.message);
  }
};
